import { render, staticRenderFns } from "./competitionSnakeBroadcastScreenOption.vue?vue&type=template&id=ef3ae478&scoped=true"
import script from "./competitionSnakeBroadcastScreenOption.vue?vue&type=script&lang=ts"
export * from "./competitionSnakeBroadcastScreenOption.vue?vue&type=script&lang=ts"
import style0 from "./competitionSnakeBroadcastScreenOption.vue?vue&type=style&index=0&id=ef3ae478&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef3ae478",
  null
  
)

export default component.exports